import { useCallback, useEffect, useState } from 'react'
import { ReservationForm } from './reservation-form'
import { Modal, ModalProps } from '@elements/modal'

import { utcToISO } from '@utils/date-time'
import { Venue } from 'types/model'
import { Button } from '@elements/button'
import { AdmissionGroup } from 'types/model/admission-group'
import { ReservationConfirmationCopy } from './reservation-confirmation-copy'
import { TrackingEvent } from 'shared'
import { trackEvent } from '@lib/track'

export function ReservationModal({
  venue,
  date,
  attributionId,
  affiliateId,
  ...modalProps
}: {
  venue?: Venue
  date: string
  attributionId?: string | null
  affiliateId?: string | null
} & ModalProps) {
  const [reservationDate, setReservationDate] = useState<string>()

  const afterSubmit = useCallback((vals: AdmissionGroup) => {
    setReservationDate(utcToISO(vals.date))
  }, [])

  useEffect(() => {
    if (!modalProps.isOpen) {
      setTimeout(() => {
        setReservationDate(undefined)
      }, 500)
    }
  }, [modalProps.isOpen])

  useEffect(() => {
    if (!modalProps.isOpen || !venue?.id) return
    void trackEvent({
      event: TrackingEvent.ViewedReservationRequest,
      venueId: venue.id,
    })
  }, [modalProps.isOpen, venue?.id])

  if (!venue) return null
  return (
    <Modal
      {...modalProps}
      fit
      title={reservationDate ? 'Request Received' : 'Request a Reservation'}
    >
      <div className='w-full max-w-full mx-auto sm:max-w-xl'>
        {!reservationDate ? (
          <ReservationForm
            date={date}
            venue={venue}
            afterSubmit={afterSubmit}
            attributionId={attributionId}
            affiliateId={affiliateId}
          />
        ) : (
          <div className='space-y-6'>
            <ReservationConfirmationCopy reservationDate={reservationDate} />
            <Button.Primary className='w-full' onClick={modalProps.close}>
              Close
            </Button.Primary>
          </div>
        )}
      </div>
    </Modal>
  )
}
